"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var usePriceFormatter_1 = require("../../../../../../common/react/usePriceFormatter");
var clsx_1 = require("clsx");
var useSummaryContext_1 = require("../../../react/useSummaryContext");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var Price = react_1.memo(function (_a) {
    var _b, _c, _d;
    var price = _a.price, priceDisplayType = _a.priceDisplayType, currency = _a.currency, className = _a.className, variant = _a.variant, dataTest = _a.dataTest, rest = __rest(_a, ["price", "priceDisplayType", "currency", "className", "variant", "dataTest"]);
    var _e = useSummaryContext_1.default().dimensions, language = _e.language, country = _e.country;
    var priceDisplay = usePlatformConfig_1.default().platformConfig.priceDisplay;
    var priceConfig = priceDisplay[priceDisplayType];
    var priceFormatter = usePriceFormatter_1.default({
        currency: currency,
        dimensions: {
            language: language,
            country: country,
        },
        decimals: (_c = (_b = priceConfig) === null || _b === void 0 ? void 0 : _b.decimalScale, (_c !== null && _c !== void 0 ? _c : 0)),
        currencyFormatConfig: (_d = priceConfig) === null || _d === void 0 ? void 0 : _d.currencyFormatConfig,
    });
    if (!currency) {
        return;
    }
    return (<core_1.Typography {...rest} component="span" data-test={dataTest} variant={(variant !== null && variant !== void 0 ? variant : 'subtitle1')} className={clsx_1.default(className)}>
        {priceFormatter.format(price)}
      </core_1.Typography>);
});
exports.default = Price;
